export function normalizeBusinessSearch(value: unknown): string {
  if (Array.isArray(value)) return value.join(',')
  if (value == null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }
  return ''
}